export default __webpack_public_path__ + "static/media/Image (11).0a93d914.png";